import { Trans, useTranslation } from 'react-i18next'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ShowMoreResults = ({ count, page, pageSize, onShowMore }) => {
  const { t } = useTranslation()

  const end = Math.min(page * pageSize, count)

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        <Trans
          i18nKey="Mostrando <bold>{{start}}-{{end}}</bold> de <bold>{{count}}</bold> resultados"
          values={{ start: 1, end, count }}
          components={{ bold: <strong /> }}
        />
      </Text>
      {end < count && (
        <Button variant="text" onClick={onShowMore}>
          {t('Mostrar más resultados')}
        </Button>
      )}
    </Styles.Container>
  )
}

export default ShowMoreResults
